import { useState, useEffect, useContext } from 'react';
import { useRouter } from 'next/router';
import Prismic from 'helpers/Prismic';
import globalProps, { globalPropsRequests } from 'utils/globalProps';
import StickyLinks from 'containers/ReadyToShip/StickyLinks';
import Head from 'next/head';
import ReadyToShipProduct from 'containers/CategoryLandingSlices/GamingProductList/readyToShipProduct';
import CategoryFourColumns from 'containers/CategoryLandingSlices/Category/categoryFourColumns';
import ProductFilter from 'components/ProductFilter';
import PageHeader from 'components/PageHeader';
import TabMenu from 'components/TabMenu';
import ImageBanner from 'components/ImageBanner';
import Error from 'components/Error';

import breakPoints, { colors } from 'helpers/Styles';
import { Element } from 'react-scroll';
import Loader from 'components/Loader';
import { StorefrontContext } from 'providers/storefront';
import { fbEvent } from '@rivercode/facebook-conversion-api-nextjs';
import TiktokPixel from 'tiktok-pixel';

import {
  sendShopifyAnalytics,
  getClientBrowserParameters,
  AnalyticsEventName,
} from '@shopify/hydrogen-react';
import Script from 'next/script';

const readyToShip = ({ handle, content }) => {
  const router = useRouter();
  const { isFallback } = useRouter();
  const ogImage = content?.og_image?.url;

  if (isFallback) {
    return <Loader />;
  }

  if (!content) {
    return <Error code={404} />;
  }

  const {
    seo_title: seoTitle,
    seo_description: seoDescription,
    title,
    description,
    body,
    body1,
  } = content;

  // const menuItems = menu.body[0].items;
  // const menuItemValues = menuItems.map((item) => item.menu_item_title);
  // const tabIndex = menuItemValues.indexOf(handle.toUpperCase());
  const buttonLabel = 'VIEW PRODUCT';
  const [activeNav, setActiveNav] = useState({});
  const [action, setAction] = useState(false);
  const [count, setCount] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const [filteredProducts, setFilteredProducts] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [activeFilter, setActiveFilter] = useState(0);
  const [filterCount, setFilterCount] = useState([]);
  const [filterCounter, setFilterCounter] = useState(0);
  const [sortActive, setSortActive] = useState('category');
  let categoryTitles = [];
  let cpuTitles = [];
  let gpuTitles = [];
  let priceRangeTitles = [];

  const { isMenuOpen, isAnnouncementBarOpen } = useContext(StorefrontContext);

  const data = body.map((bodyItem) => {
    if (typeof bodyItem.primary.filter !== 'undefined') {
      const { filter, title1, description1 } = bodyItem.primary;

      let filterKey = filter.split('-');
      let key = typeof filterKey[0] != 'undefined' && filterKey[0];
      let value = typeof filterKey[1] != 'undefined' && filterKey[1];

      if (key == 'category') {
        // categoryTitles.push({value, title: title1, description: description1});
        categoryTitles.push(value);
      } else if (key == 'cpu') {
        cpuTitles.push(value);
      } else if (key == 'gpu') {
        gpuTitles.push(value);
      } else if (key == 'price_range') {
        priceRangeTitles.push(filter.split('price_range-')[1]);
      }
    }
  });
  let filterTotalCount = 0;

  useEffect(() => {
    window.onpopstate = () => {
      if (activeFilter) {
        closeFilters();
      }
    };
  });

  const sendPageView = (analyticsPageData) => {
    const payload = {
      ...getClientBrowserParameters(),
      ...analyticsPageData,
    };
    sendShopifyAnalytics({
      eventName: AnalyticsEventName.PAGE_VIEW,
      payload,
    });
  };

  const analyticsShopData = {
    shopId: 'gid://shopify/Shop/63704072436',
    currency: 'SGD',
    acceptedLanguage: 'en',
  };

  const hasUserConsent = true;

  const analytics = {
    hasUserConsent,
    ...analyticsShopData,
  };

  useEffect(() => {
    const productHandle = sessionStorage.getItem('productHandle');

    if (router.asPath == '/ready-to-ship/desktops' && productHandle == null) {
      handleClearAll();
    }

    const urlParams = new URLSearchParams(window.location.search);
    let params = '';
    urlParams.forEach((element) => {
      params = params.concat(',', element);
    });
    setFilterCounter(params.split(',').length - 1);
    let filteredItems = body.map((bodyItem) => {
      return bodyItem.items;
    });
    let filtered = filteredItems.map((el) => {
      return el.filter((itm) => itm.product !== null);
    });
    const flatProducts = filtered.flat();
    const finalProducts = flatProducts.filter((el) => el.product !== undefined);
    setTotalCount(finalProducts.length);

    fbEvent({
      eventName: 'PageView',
      products: [
        {
          sku: window.location.pathname,
          quantity: 1,
        },
      ],
      enableStandardPixel: false,
    });

    const options = {
      debug: false, // enable logs
    };

    TiktokPixel.init(process.env.NEXT_PUBLIC_TIKTOK_PIXEL_ID, options);
    TiktokPixel.pageView(); // For tracking page view

    sendPageView(analytics);

    return () => {
      sessionStorage.removeItem('productHandle');
    };
  }, [router.asPath]);

  const categories = body1.filter((n) => n.slice_type === 'category')[0];
  const [selectedOption, setSelectedOption] = useState(
    categories?.items[0].category_tag[0].text
  );

  const handleMainCategory = (type) => {
    setSelectedOption(type);
  };

  useEffect(() => {
    const data = router.query;
    delete data.handle;
    if (
      (data &&
        Object.keys(data).length != 0 &&
        !count &&
        !trigger &&
        filteredProducts !== null) ||
      selectedOption
    ) {
      if (typeof data.category !== 'undefined') {
        let paramsArr = data.category.split(',');
        paramsArr.map((itm) => {
          updateFilterCount(itm, 'category');
        });
      }
      if (typeof data.cpu !== 'undefined') {
        let paramsArr = data.cpu.split(',');
        paramsArr.map((itm) => {
          updateFilterCount(itm, 'cpu');
        });
      }
      if (typeof data.gpu !== 'undefined') {
        let paramsArr = data.gpu.split(',');
        paramsArr.map((itm) => {
          updateFilterCount(itm, 'gpu');
        });
      }
      if (typeof data.price_range !== 'undefined')
        updateFilterCount(data.price_range, 'price_range');
      if (typeof data.sort_by !== 'undefined')
        updateFilterCount(data.sort_by, 'sort_by');

      setCount(true);
    }
    if (data && Object.keys(data).length !== 0) {
      let categoryData = [];
      const filterArray = handleFlatArray(body);
      const arr = filterArray;
      if (typeof data.category !== 'undefined') {
        let paramsArr = data.category.split(',');
        paramsArr?.map((el) => {
          filterArray.filter((itm) => {
            const { product } = itm;
            const productTags = product.tags.split(',');
            const filterTags = productTags.filter((item) =>
              item.trim().startsWith('category:')
            );

            const shippingTags = productTags.filter((item) =>
              item.trim().startsWith('shipping:')
            );

            const shippingCategories = shippingTags.map((item) => {
              const trimmmedTag = item.replace('shipping:', 'category:');
              return trimmmedTag.trim();
            });

            const addedShippingTags = [...filterTags, ...shippingCategories];
            const category =
              addedShippingTags.length > 0 && addedShippingTags[0]?.split(':');
            if (category.length > 0) category?.shift();

            addedShippingTags.forEach((filt, idx) => {
              const check = !!categoryData.filter(function (data) {
                return data.product.id == product.id;
              }).length;
              const res = paramsArr.find(
                (dataCat) =>
                  dataCat.replace(/ /g, '').toLowerCase() ===
                  filt.replace(/ /g, '').toLowerCase().split(':')[1]
              );
              if (res) {
                if (!check) {
                  return categoryData.push(itm);
                }
              }
            });
          });
        });
      }
      let cpuData = [];
      let gpuData = [];
      let filterData =
        categoryData.length > 0 ? categoryData : handleFlatArray(body);

      if (categoryData.length > 0) filterData = categoryData;
      else if (typeof data?.category !== 'undefined') filterData = categoryData;

      if (typeof data?.cpu !== 'undefined') {
        let paramsArr = data?.cpu.split(',');
        paramsArr?.map((el) => {
          filterData.filter((itm) => {
            const { product } = itm;
            const productTags = product.tags.split(',');
            const filterTags = productTags.filter((item) =>
              item.trim().startsWith('cpu:')
            );

            const cpu = filterTags.length > 0 && filterTags[0].split(':')[1];
            if (
              cpu &&
              cpu.replace(/ /g, '').toLowerCase() ===
                el.replace(/ /g, '').toLowerCase()
            )
              return cpuData.push(itm);
          });
        });
      }

      if (cpuData.length > 0) filterData = cpuData;
      else if (typeof data?.cpu !== 'undefined') filterData = cpuData;

      if (typeof data?.gpu !== 'undefined') {
        let paramsArr = data?.gpu.split(',');
        paramsArr?.map((el) => {
          filterData.filter((itm) => {
            const { product } = itm;
            const productTags = product.tags.split(',');
            const filterTags = productTags.filter((item) =>
              item.trim().startsWith('gpu:')
            );

            const gpu = filterTags.length > 0 && filterTags[0].split(':')[1];

            const checkGpu = filterTags.filter(item => {
              const splitItem = item.split(':')[1].replace(/ /g, '').toLowerCase();
              return splitItem === el.replace(/ /g, '').toLowerCase();
            });

            if ( gpu && checkGpu.length > 0) {
              return gpuData.push(itm);
            }
          });
        });
      }

      if (gpuData.length > 0) filterData = gpuData;
      else if (typeof data?.gpu !== 'undefined') filterData = gpuData;

      let latestArray = filterData;

      if (typeof data?.sort_by !== 'undefined') {
        latestArray.sort((a, b) => {
          if (data?.sort_by.toUpperCase() == 'PRICE LOW - HIGH') {
            return a.product?.variants[0].price - b.product?.variants[0].price;
          } else if (data?.sort_by.toUpperCase() == 'PRICE HIGH - LOW') {
            return b.product?.variants[0].price - a.product?.variants[0].price;
          }
        });
      }

      if (typeof data?.price_range !== 'undefined') {
        const price = data?.price_range.replace(/\$/g, '');
        const lowPrice = price.split('-')[0];
        const highPrice = price.split('-')[1];

        let newProducts = latestArray.filter((itm) => {
          const { product } = itm;
          return highPrice !== null && highPrice !== undefined
            ? product?.variants[0]?.price >= parseInt(lowPrice) &&
                product?.variants[0]?.price <= parseInt(highPrice)
            : product?.variants[0]?.price >= parseInt(lowPrice);
        });

        if (selectedOption != categories?.items[0].category_tag[0].text) {
          let filteredMainCategory = [];
          newProducts.filter((itm) => {
            const { product } = itm;
            const productTags = product.tags?.split(',');
            const filterTags = productTags.filter((item) =>
              item.trim().startsWith('maincategory:')
            );

            const category = filterTags.length > 0 && filterTags[0]?.split(':');

            if (category[1] == selectedOption) {
              filteredMainCategory.push(itm);
            }
          });
          setFilteredProducts(filteredMainCategory);
        } else {
          setFilteredProducts(newProducts);
        }
      } else if (
        typeof data?.price_range === 'undefined' &&
        typeof data?.gpu === 'undefined' &&
        typeof data?.cpu === 'undefined' &&
        typeof data?.category === 'undefined' &&
        typeof data?.sort_by !== 'undefined'
      ) {
        let categoryDataPC = [];
        let categoryDataWorkstation = [];
        let categoryDataLaptop = [];
        const filterArray = handleFlatArray(body);

        filterArray.filter((itm) => {
          const { product } = itm;
          const productTags = product.tags?.split(',');
          const filterTags = productTags.filter((item) =>
            item.trim().startsWith('category:')
          );

          const shippingTags = productTags.filter((item) =>
            item.trim().startsWith('shipping:')
          );

          const shippingCategories = shippingTags.map((item) => {
            const trimmmedTag = item.replace('shipping:', 'category:');
            return trimmmedTag.trim();
          });
          const addedShippingTags = [...filterTags, ...shippingCategories];
          const category =
            addedShippingTags.length > 0 && addedShippingTags[0]?.split(':');
          if (category.length > 0) category?.shift();

          const checkPC = !!categoryDataPC.filter(function (data) {
            return data.product.id == product.id;
          }).length;

          for (let i = 0; i < category.length; i++) {
            if (
              category[i].replace(/ /g, '').toLowerCase() !== 'laptops' &&
              category[i].replace(/ /g, '').toLowerCase() !== 'workstations'
            ) {
              if (!checkPC) {
                categoryDataPC.push(itm);
              }
            }
          }

          const checkWorkstation = !!categoryDataWorkstation.filter(
            function (data) {
              return data.product.id == product.id;
            }
          ).length;

          for (let i = 0; i < category.length; i++) {
            if (
              category[i].replace(/ /g, '').toLowerCase() === 'workstations'
            ) {
              if (!checkWorkstation) {
                categoryDataWorkstation.push(itm);
              }
            }
          }

          const checkLaptop = !!categoryDataLaptop.filter(function (data) {
            return data.product.id == product.id;
          }).length;

          for (let i = 0; i < category.length; i++) {
            if (category[i].replace(/ /g, '').toLowerCase() === 'laptops') {
              if (!checkLaptop) {
                categoryDataLaptop.push(itm);
              }
            }
          }
        });

        categoryDataPC.sort((a, b) => {
          if (data?.sort_by.toUpperCase() == 'PRICE LOW - HIGH') {
            return a.product?.variants[0].price - b.product?.variants[0].price;
          } else if (data?.sort_by.toUpperCase() == 'PRICE HIGH - LOW') {
            return b.product?.variants[0].price - a.product?.variants[0].price;
          }
        });

        categoryDataWorkstation.sort((a, b) => {
          if (data?.sort_by.toUpperCase() == 'PRICE LOW - HIGH') {
            return a.product?.variants[0].price - b.product?.variants[0].price;
          } else if (data?.sort_by.toUpperCase() == 'PRICE HIGH - LOW') {
            return b.product?.variants[0].price - a.product?.variants[0].price;
          }
        });

        categoryDataLaptop.sort((a, b) => {
          if (data?.sort_by.toUpperCase() == 'PRICE LOW - HIGH') {
            return a.product?.variants[0].price - b.product?.variants[0].price;
          } else if (data?.sort_by.toUpperCase() == 'PRICE HIGH - LOW') {
            return b.product?.variants[0].price - a.product?.variants[0].price;
          }
        });

        if (selectedOption != categories?.items[0].category_tag[0].text) {
          let filteredMainCategory = [];
          let filteredProducts = [
            ...categoryDataPC,
            ...categoryDataWorkstation,
            ...categoryDataLaptop,
          ];
          filteredProducts.filter((itm) => {
            const { product } = itm;
            const productTags = product.tags?.split(',');
            const filterTags = productTags.filter((item) =>
              item.trim().startsWith('maincategory:')
            );

            const category = filterTags.length > 0 && filterTags[0]?.split(':');

            if (category[1] == selectedOption) {
              filteredMainCategory.push(itm);
            }
          });
          setFilteredProducts(filteredMainCategory);
        } else {
          setFilteredProducts([
            ...categoryDataPC,
            ...categoryDataWorkstation,
            ...categoryDataLaptop,
          ]);
        }
      } else {
        if (selectedOption != categories?.items[0].category_tag[0].text) {
          let filteredMainCategory = [];
          latestArray.filter((itm) => {
            const { product } = itm;
            const productTags = product.tags?.split(',');
            const filterTags = productTags.filter((item) =>
              item.trim().startsWith('maincategory:')
            );

            const category = filterTags.length > 0 && filterTags[0]?.split(':');

            if (category[1] == selectedOption) {
              filteredMainCategory.push(itm);
            }
          });
          setFilteredProducts(filteredMainCategory);
        } else {
          setFilteredProducts(latestArray);
        }
      }
    } else if (
      Object.keys(data).length === 0 &&
      filteredProducts != null &&
      action
    ) {
      handleClearAll();
      setAction(false);
    } else {
      if (filteredProducts == null) {
        let filteredItems = body.map((bodyItem) => {
          return bodyItem.items;
        });
        let filtered = filteredItems.map((el) => {
          return el.filter((itm) => itm.product !== null);
        });
        const flatProducts = filtered.flat();
        const finalProducts = flatProducts.filter(
          (el) => el.product !== undefined
        );

        setTotalCount(finalProducts.length);
        setFilteredProducts(finalProducts);
      } else {
        let filteredItems = body.map((bodyItem) => {
          return bodyItem.items;
        });
        let filtered = filteredItems.map((el) => {
          return el.filter((itm) => itm.product !== null);
        });
        const flatProducts = filtered.flat();
        const finalProducts = flatProducts.filter(
          (el) => el.product !== undefined
        );

        if (selectedOption != categories?.items[0].category_tag[0].text) {
          let filteredMainCategory = [];
          finalProducts.filter((itm) => {
            const { product } = itm;
            const productTags = product.tags?.split(',');
            const filterTags = productTags.filter((item) =>
              item.trim().startsWith('maincategory:')
            );

            const category = filterTags.length > 0 && filterTags[0]?.split(':');

            if (category[1] == selectedOption) {
              filteredMainCategory.push(itm);
            }
          });
          setFilteredProducts(filteredMainCategory);
        } else {
          setTotalCount(finalProducts.length);
          setFilteredProducts(finalProducts);
        }
      }
    }
  }, [router.query, action, selectedOption]);

  useEffect(() => {
    if (activeFilter && window.innerWidth <= 540) {
      document.body.setAttribute('style', 'overflow: hidden; position: fixed;');
    } else {
      document.body.setAttribute('style', 'overflow: unset; position: unset;');
    }
  }, [activeFilter]);

  filterTotalCount += filteredProducts != null ? filteredProducts.length : 0;
  const updateFilterCount = async (item, type, action = null) => {
    if (action) {
      if (type === 'price_range') {
        let finalItems = '';
        if (priceRangeTitles.includes(item)) {
          finalItems = 'price_range';
        }
        let filter = filterCount.filter((el) => el != finalItems);
        setFilterCount(filter);
        setFilterCounter(filter.length);
      } else if (type === 'sort_by') {
        const sortByItems = ['PRICE LOW - HIGH', 'PRICE HIGH - LOW'];
        let finalItems = '';
        if (sortByItems.includes(item)) {
          finalItems = 'sort_by';
        }
        let filter = filterCount.filter((el) => el !== finalItems);
        setFilterCount(filter);
        setFilterCounter(filter.length);
      } else {
        let newitems = filterCount.filter((el) => el != item);
        setFilterCount(newitems);
        setFilterCounter(newitems.length);
      }
    } else {
      if (!filterCount.includes(item)) {
        if (type === 'price_range') {
          let finalItems = '';
          if (priceRangeTitles.includes(item)) {
            finalItems = 'price_range';
          }
          let filter = filterCount.filter((el) => el !== finalItems);
          setFilterCount([...filter, finalItems]);
          setFilterCounter([...filter, finalItems].length);
        } else if (type === 'sort_by') {
          const sortByItems = ['PRICE LOW - HIGH', 'PRICE HIGH - LOW'];
          let finalItems = '';
          if (sortByItems.includes(item)) {
            finalItems = 'sort_by';
          }
          let filter = filterCount.filter((el) => el !== finalItems);

          setFilterCount([...filter, finalItems]);
          setFilterCounter([...filter, finalItems].length);
        } else {
          filterCount.push(item);

          setFilterCount(filterCount);
          setFilterCounter(filterCount.length);
        }
      }
    }
  };

  const handleFlatArray = (arr) => {
    let filteredItems = arr.map((bodyItem) => {
      return bodyItem.items;
    });
    let filtered = filteredItems.map((el) => {
      return el.filter((itm) => {
        return itm && itm.product && itm.product !== null;
      });
    });
    const flatProducts = filtered.flat();
    flatProducts.filter((el) => el.product !== null);
    return flatProducts;
  };
  const handleMergeArray = (arr1, arr2, arr3, action = false) => {
    let latestArr = [];
    let mergeArray = arr1.concat(arr2);
    mergeArray = mergeArray.concat(arr3);
    let filterData = mergeArray.length > 0 ? mergeArray : body;
    latestArr = handleFlatArray(filterData);
    const removeDuplticateData = latestArr.filter(
      (value, index, self) =>
        index === self.findIndex((itm) => itm.product.id === value.product.id)
    );
    return removeDuplticateData;
  };

  const handleActiveNav = async (index, type, item, action = null) => {
    if (item == 'Same Day Delivery') {
      item = 'same-day-shipping';
    }

    setTrigger(true);
    if (action) {
      const data = router.query;
      delete data.handle;
      let params = data[type];
      if (typeof params !== 'undefined') {
        const arr = params.split(',');
        let filterArr = [];
        arr.map((itm) => {
          itm !== item.toLowerCase() && filterArr.push(itm);
        });
        params = filterArr.join();
      }
      if (params == '') {
        delete data[type];
        setAction(true);
        router.push(
          {
            pathname: `/ready-to-ship/${handle}`,
            query: { ...data },
          },
          undefined,
          { shallow: true }
        );
      } else {
        router.push(
          {
            pathname: `/ready-to-ship/${handle}`,
            query: { ...data, [type]: params.toLowerCase() },
          },
          undefined,
          { shallow: true }
        );
      }
      updateFilterCount(item.toLowerCase(), type, 'remove');
    } else {
      const data = router.query;
      delete data.handle;
      if (type === 'category' || type === 'cpu' || type === 'gpu') {
        let params = data[type];

        if (typeof params !== 'undefined') {
          params = params + ',' + item;
        } else {
          params = item;
        }
        router.push(
          {
            pathname: `/ready-to-ship/${handle}`,
            query: {
              ...data,
              [type]: params.toLowerCase(),
            },
          },
          undefined,
          { shallow: true }
        );
      } else if (type === 'price_range' || type === 'sort_by') {
        router.push(
          {
            pathname: `/ready-to-ship/${handle}`,
            query: {
              ...data,
              [type]: item.toLowerCase(),
            },
          },
          undefined,
          { shallow: true }
        );
      }
      updateFilterCount(item.toLowerCase(), type);
    }
  };
  const handleClearAll = () => {
    const latestArray = handleFlatArray(body);
    setFilteredProducts(latestArray);
    router.push(
      {
        pathname: `/ready-to-ship/${handle}`,
      },
      undefined,
      { shallow: true }
    );
    setFilterCount([]);
    setFilterCounter(0);
    sessionStorage.removeItem('productHandle');
    // setSortActive('category');
  };

  const handleSortActive = (value) => {
    setSortActive(value);
  };

  const closeFilters = () => {
    setActiveFilter(!activeFilter);
  };

  const [urlState, setUrlState] = useState({
    category: [],
    index: [],
    item: [],
  });

  const updateUrlParams = (index, type, item, action) => {
    console.log(index);
    console.log(type);
    console.log(item);
    // console.log(action)

    console.log(urlState);
    const CATEGORY = [];
    CATEGORY.push(type);
    setUrlState({ ...urlState, category: CATEGORY });

    router.push({
      pathname: 'desktops',
      query: urlState,
    }),
      undefined,
      { shallow: true };
  };

  return (
    <>
      <Head>
        <link
          rel="preconnect dns-prefetch"
          href="https://triplewhale-pixel.web.app/"
          crossOrigin="true"
        />
        <link
          rel="preconnect dns-prefetch"
          href="https://api.config-security.com/"
          crossOrigin="true"
        />
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta property="og:image" content={ogImage ? ogImage : "https://cdn.shopify.com/s/files/1/0637/0407/2436/files/ogImage.png?v=1714058511"} />
      </Head>
	<Script src="/tripleWhale.js" dangerouslySetInnerHTML={{ __html: 'TripleHeadless = "aftershockpcsg.myshopify.com"' }} strategy='lazyOnload' />
      <main>
        {content?.desktop_banner &&
        Object.keys(content.desktop_banner).length !== 0 &&
        content?.mobile_banner &&
        Object.keys(content.mobile_banner).length !== 0 ? (
          <ImageBanner
            bannerImage={content.desktop_banner}
            bannerImageMobile={content.mobile_banner}
          />
        ) : null}
        <div className="main-wrapper">
          <div className="headerFilter wrapper wrapp_filter">
            <div>
              <span className="filterLabel">{totalCount} PRODUCTS </span>
            </div>
            <div
              className="filterLabel filterLabel-filter"
              onClick={() => closeFilters()}
            >
              <img draggable="false" 
                src="https://cdn.shopify.com/s/files/1/0637/0407/2436/files/icon-filter.png?v=1714031886"
                alt="first_level menu"
                layout="fixed"
                width={15}
                height={15}
              />
              <span className="filterLabel filterLabel-filter">
                FILTER & SORT
              </span>
              <span className="filterLabel-filters-count">{filterCounter}</span>
            </div>
          </div>
          {activeFilter ? (
            <div className="header">
              <div className="filtersBtn">
                <div className="inner_btns">
                  <button
                    onClick={() => handleSortActive('category')}
                    className={sortActive == 'category' ? 'active' : ''}
                  >
                    CATEGORY
                  </button>
                  <button
                    onClick={() => handleSortActive('cpu')}
                    className={sortActive == 'cpu' ? 'active' : ''}
                  >
                    CPU
                  </button>
                  <button
                    onClick={() => handleSortActive('gpu')}
                    className={sortActive == 'gpu' ? 'active' : ''}
                  >
                    GPU
                  </button>
                  <button
                    onClick={() => handleSortActive('price_range')}
                    className={sortActive == 'price_range' ? 'active' : ''}
                  >
                    PRICE RANGE
                  </button>
                  <button
                    onClick={() => handleSortActive('sort_by')}
                    className={sortActive == 'sort_by' ? 'active' : ''}
                  >
                    SORT BY
                  </button>
                </div>
                <div className="our_btns">
                  {sortActive === 'category' ? (
                    [1].length > 0 ? (
                      categoryTitles.map((item, listIndex) => (
                        <ProductFilter
                          item={item}
                          listIndex={listIndex}
                          key={item}
                          type={sortActive}
                          handleActiveNav={handleActiveNav}
                          activeNav={activeNav}
                        />
                      ))
                    ) : (
                      <p>No product filter available </p>
                    )
                  ) : sortActive === 'cpu' ? (
                    [1].length > 0 ? (
                      cpuTitles.map((item, listIndex) => (
                        <ProductFilter
                          item={item}
                          listIndex={listIndex}
                          key={item}
                          type={sortActive}
                          handleActiveNav={handleActiveNav}
                          activeNav={activeNav}
                        />
                      ))
                    ) : (
                      <p>No product filter available </p>
                    )
                  ) : sortActive === 'gpu' ? (
                    [1].length > 0 ? (
                      gpuTitles.map((item, listIndex) => (
                        <ProductFilter
                          item={item}
                          listIndex={listIndex}
                          key={item}
                          type={sortActive}
                          handleActiveNav={handleActiveNav}
                          activeNav={activeNav}
                        />
                      ))
                    ) : (
                      <p>No product filter available </p>
                    )
                  ) : sortActive === 'price_range' ? (
                    priceRangeTitles.map((item, listIndex) => (
                      <ProductFilter
                        item={item}
                        listIndex={listIndex}
                        key={item}
                        type={sortActive}
                        handleActiveNav={handleActiveNav}
                        activeNav={activeNav}
                      />
                    ))
                  ) : (
                    sortActive === 'sort_by' &&
                    ['PRICE LOW - HIGH', 'PRICE HIGH - LOW'].map(
                      (item, listIndex) => (
                        <ProductFilter
                          item={item}
                          listIndex={listIndex}
                          key={item}
                          type={sortActive}
                          handleActiveNav={handleActiveNav}
                          activeNav={activeNav}
                        />
                      )
                    )
                  )}
                </div>
                <div className="results">
                  <label>{filterTotalCount} results</label>
                  <div className="results-divider"></div>
                  <label className="clear">
                    <span>{filterCount.length}</span>
                    <a
                      href="javascript:void(0);"
                      className="clearFilter"
                      onClick={() => handleClearAll()}
                    >
                      Clear Filters
                    </a>
                  </label>
                </div>
              </div>
              <div className="filtersBtn__mobile">
                <div className="our_btns">
                  <label className="clear">
                    <span>{filterCount.length}</span>
                    <a
                      href="javascript:void(0);"
                      className="clearFilter"
                      onClick={() => handleClearAll()}
                    >
                      Clear Filters
                    </a>
                  </label>
                  <div className="our_btns-item-mobile">
                    <h1 className="our_btns-item-title">CATEGORY</h1>
                    {categoryTitles.map((item, listIndex) => (
                      <ProductFilter
                        item={item}
                        listIndex={listIndex}
                        key={item}
                        type={'category'}
                        handleActiveNav={handleActiveNav}
                        activeNav={activeNav}
                      />
                    ))}
                  </div>

                  <div className="our_btns-item-mobile">
                    <h1 className="our_btns-item-title">CPU</h1>
                    {cpuTitles.map((item, listIndex) => (
                      <ProductFilter
                        item={item}
                        listIndex={listIndex}
                        key={item}
                        type={'cpu'}
                        handleActiveNav={handleActiveNav}
                        activeNav={activeNav}
                      />
                    ))}
                  </div>

                  <div className="our_btns-item-mobile">
                    <h1 className="our_btns-item-title">GPU</h1>
                    {gpuTitles.map((item, listIndex) => (
                      <ProductFilter
                        item={item}
                        listIndex={listIndex}
                        key={item}
                        type={'gpu'}
                        handleActiveNav={handleActiveNav}
                        activeNav={activeNav}
                      />
                    ))}
                  </div>

                  <div className="our_btns-item-mobile">
                    <h1 className="our_btns-item-title">PRICE RANGE</h1>
                    {priceRangeTitles.map((item, listIndex) => (
                      <ProductFilter
                        item={item}
                        listIndex={listIndex}
                        key={item}
                        type={'price_range'}
                        handleActiveNav={handleActiveNav}
                        activeNav={activeNav}
                        fullWidth={true}
                      />
                    ))}
                  </div>

                  <div className="our_btns-item-mobile">
                    <h1 className="our_btns-item-title">SORT BY</h1>
                    {['PRICE LOW - HIGH', 'PRICE HIGH - LOW'].map(
                      (item, listIndex) => (
                        <ProductFilter
                          item={item}
                          listIndex={listIndex}
                          key={item}
                          type={'sort_by'}
                          handleActiveNav={handleActiveNav}
                          activeNav={activeNav}
                          fullWidth={true}
                        />
                      )
                    )}
                  </div>
                </div>
              </div>
              <button
                className="hideFilterButton"
                onClick={() => closeFilters()}
              >
                <img draggable="false" 
                  src="https://cdn.shopify.com/s/files/1/0637/0407/2436/files/ChevronUpDouble.svg?v=1714040296"
                  className="hideFilterIcon"
                  alt="hide-button"
                />
              </button>
              <button
                className="closeFilterButton"
                onClick={() => closeFilters()}
              >
                <img draggable="false" 
                  src="https://cdn.shopify.com/s/files/1/0637/0407/2436/files/icon-close_5.png?v=1714062936"
                  className="closeFilterIcon"
                  alt="close-button"
                />
              </button>

              <div className="results results-mobile">
                <label onClick={() => closeFilters()}>
                  APPLY - {filterTotalCount} RESULTS
                </label>
              </div>
            </div>
          ) : null}
        </div>

        <div className="wrapper">
          <div className="tabContent">
            <div className="gaming_product_list anchor-container">
              {categories && (
                <CategoryFourColumns
                  categories={categories}
                  handleMainCategory={handleMainCategory}
                />
              )}

              {filteredProducts != null && filteredProducts.length > 0 ? (
                <Element name="TEST" className="element">
                  <ReadyToShipProduct
                    key={'a'}
                    data={filteredProducts}
                    buttonLabel={buttonLabel}
                    fixedPrice
                    readyToShip
                    title={title}
                    description={description}
                    filterCount={filterCount.length || 0}
                    handleClearFilter={() => handleClearAll()}
                  />
                </Element>
              ) : (
                <p className="text-center"> No Result Found</p>
              )}
            </div>
          </div>
        </div>
      </main>
      <style jsx>
        {`
          .hideFilterButton {
            margin: auto;
            margin-top: 10px;
            display: flex;
            justify-content: center;
            background: none;
            border: none;
            outline: none;
            user-select: none;
          }

          .hideFilterIcon {
            height: 24px;
          }

          .closeFilterButton {
            position: absolute;
            z-index: 10;
            right: 10px;
            top: 15px;
            background: none;
            border: none;
            outline: none;
            user-select: none;
            display: block;
          }
          @media (min-width: 541px) {
            .closeFilterButton {
              display: none;
            }
          }
          .results label {
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            text-align: right;
            color: #949494;
            font-family: 'Roboto-Medium';
          }

          .results-divider {
            width: 1px;
            height: 32px;
            background: #242424;
          }

          .results label span {
            color: #fff;
            text-align: center;
          }

          .our_btns-item-mobile {
            text-align: left;
          }

          .our_btns-item-title {
            font-style: normal;
            font-weight: 600;
            font-size: 13px;
            line-height: 24px;
            color: #949494;
            margin-top: 32px;
            margin-bottom: 16px;
          }

          .clear a {
            color: #fff;
          }
          .text-center {
            text-align: center;
          }
          .headerFilter {
            font-style: normal;
            font-weight: 600;
            font-size: 13px;
            line-height: 24px;
            cursor: pointer;
          }

          .filterLabel {
            font-style: normal;
            font-size: 13px;
            line-height: 24px;
            cursor: pointer;
            font-weight: 400;
            color: #949494;
          }

          .filterLabel-filter {
            color: #e4e4e4;
          }
          .filterLabel-filters-count {
            width: 20px;
            height: 20px;
            background: #950810;
            display: inline-block;
            border-radius: 50%;
            font-style: normal;
            font-weight: 600;
            font-size: 13px;
            line-height: 20px;
            margin-right: 12px;
            margin-left: 8px;
            text-align: center;
          }

          label.clear span {
            width: 20px;
            height: 20px;
            background: #950810;
            display: inline-block;
            border-radius: 50%;
            font-style: normal;
            font-weight: 600;
            font-size: 13px;
            line-height: 20px;
            margin-right: 12px;
          }
          label.clear button {
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            text-decoration-line: underline;
          }
          .cross {
            position: absolute;
            top: 17px;
            right: 17px;
            display: inline-block;
            cursor: pointer;
          }
          .results {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 16px;
            max-width: 275px;
            margin: 1% auto 0px;
          }
          .filtersBtn,
          .filtersBtn__mobile {
            max-width: 500px;
            text-align: center;
            margin: 0px auto;
          }
          .filtersBtn__mobile {
            display: none;
            overflow-y: auto;
          }
          .filtersBtn__mobile .clear {
            display: flex;
          }
          @media (max-width: ${breakPoints.mobileExtraLarge}) {
            .filtersBtn {
              display: none;
            }
            .filtersBtn__mobile {
              display: block;
            }
          }

          .clearFilter {
            text-decoration: underline;
          }
          .inner_btns button {
            background: transparent;
            color: #e4e4e4;
            font-style: normal;
            font-weight: 600;
            font-size: 13px;
            line-height: 24px;
            border-radius: 2px;
            padding: 2px 8px;
            border: none;
            margin-right: 7px;
            font-family: 'Roboto-Medium';
            opacity: 0.75;
          }

          .inner_btns button.active {
            background: #950810;
            opacity: 1;
          }
          .inner_btns {
            width: 100%;
            display: inline-block;
            margin-bottom: 5%;
          }
          .filterBtn {
            padding: 65px;
          }
          .headerFilter img {
            filter: invert(0.5);
            width: 19px;
            height: auto;
            position: relative;
            top: 2px;
            right: 11px;
          }

          .headerFilter {
            display: flex;
            justify-content: space-between;
            padding: 15px;
          }
          .main-wrapper {
            padding-bottom: ${activeFilter ? '24px' : '0'};
            background-color: #141414;
            height: ${activeFilter ? 'unset' : '54px'};
            overflow: ${activeFilter ? 'unset' : 'hidden'};
            position: ${isMenuOpen ? 'unset' : 'sticky'};
            top: 46px;
            z-index: 3;
            width: 1435px;
            margin: 0 auto;
          }

          @media (max-width: 1435px) {
            .main-wrapper {
              width: 100%;
            }
          }

          .main-wrapper .wrapp_filter {
            max-width: 1440px;
            padding-left: 48px;
            padding-right: 48px;
          }

          @media (max-width: ${breakPoints.mobileM}) {
            .wrapp_filter {
              padding-left: 8px !important;
              padding-right: 8px !important;
            }
          }

          .main-wrapper .header {
            padding: 50px 15px;
            padding-top: 80px;
            background-color: #000000;
            position: relative;
            width: 75%;
            margin: auto;
            border-radius: 4px;
          }
          @media (min-width: 384px) {
            .main-wrapper .header {
              padding: 15px;
              padding-top: 30px;
            }
          }
          @media (min-width: 541px) {
            .main-wrapper .header {
              padding: 15px;
              padding-top: 15px;
            }
          }
          .header .cross {
            text-align: right;
          }

          .tabContent {
            display: flex;
          }
          .sticky_list {
            flex: 1;
          }
          .sticky_list ul {
            position: sticky;
            top: 100px;
            padding-top: 50px;
            padding-right: 10px;
            list-style-type: none;
            margin-bottom: 0px;
            padding-bottom: 16px;
            padding-left: 0px;
          }

          .gaming_product_list {
            flex: 3;
            display: flex;
            flex-direction: column;
            margin-left: auto;
            width: -webkit-fill-available;
          }
          .active_link button {
            background-color: ${colors.brandSecondary};
            font-family: 'Roboto-Bold';
          }
          .button_arrow {
            padding: 15px 20px;
            background-color: #242424;
          }
          main {
            background-color: ${colors.n500};
          }
          @media (max-width: ${breakPoints.medium}) {
            .main-wrapper {
              top: ${isAnnouncementBarOpen ? '78px' : '46px'};
            }

            .tabContent {
              flex-direction: column;
              justify-content: center;
            }
            .gaming_product_list {
              width: 100%;
            }
            .sticky_list {
              position: sticky;
              top: 32px;
              background-color: black;
              z-index: 1;
            }
            .sticky_list ul {
              white-space: nowrap;
              overflow-x: scroll;
              padding-top: 10px;
              display: flex;
            }
          }

          .bottom_info {
            padding: 60px 0 80px 0;
            color: #e4e4e4;
            font-family: 'Roboto-Normal';
            font-size: 16px;
            letter-spacing: 0;
            line-height: 24px;
            text-align: center;
            width: 30%;
            justify-content: center;
            margin: auto;
          }

          .results-mobile {
            display: none;
          }

          @media (max-width: ${breakPoints.medium}) {
            .bottom_info {
              width: 100%;
            }
            .main-wrapper {
              height: 40px;
            }
            .main-wrapper .wrapp_filter {
              padding-bottom: 0px;
              padding-top: 10px;
            }
          }
          @media (max-width: ${breakPoints.small}) {
            .main-wrapper .header {
              width: 100%;
            }
          }

          @media (max-width: ${breakPoints.mobileExtraLarge}) {
            .main-wrapper {
              position: ${activeFilter ? 'unset' : 'sticky'};
            }

            .main-wrapper .header {
              position: absolute;
              background-color: #141414;
              top: 0;
              left: 0;
              z-index: 22;
              height: 100vh;
              width: 100vw;
              display: flex;
              flex-direction: column;
              justify-content: center;
              overflow-y: scroll;
              padding-bottom: 110px;
            }

            .results-mobile {
              display: flex;
              width: 100%;
              max-width: 540px !important;
              position: fixed;
              bottom: 0;
              z-index: 100;
              border-top: 1px solid #646464;
              margin: 0px auto;
              overflow: hidden;
              background-color: #141414;
            }

            .results-mobile > label {
              width: 100%;
              max-width: 237px;
              text-align: center;
              padding: 12px 0;
              background: #950810;
              color: #e4e4e4;
              margin-top: 23px;
              margin-bottom: 24px;
              border-radius: 4px;
              cursor: pointer;
            }
          }

          @media (max-width: 450px) and (max-height: 740px) {

            .main-wrapper {
              top: ${isAnnouncementBarOpen ? '78px' : '46px'};
            }
          }

          @media (max-width: 425px) {
            .sticky_list::after {
              content: '';
              width: 60px;
              background: linear-gradient(
                to left,
                rgba(0, 0, 0, 1),
                rgba(0, 0, 0, 0.2)
              );
              height: 100%;
              position: absolute;
              right: 0;
              top: 0;
            }
            .cross.jsx-2980388124 {
              right: 48px;
            }
          }
        `}
      </style>
    </>
  );
};

export async function getStaticProps({ params, preview = false, previewData }) {
  const { handle } = params;
  const { ref } = previewData || {};
  const {
    props: { global },
  } = await globalProps();

  let menu = null;
  globalPropsRequests.push(
    Prismic.getByUID('page_menu', 'menu_rts', ref ? { ref } : null)
      .then((res) => ['menu_rts', res])
      .catch(() => null)
  );
  globalPropsRequests.push(
    Prismic.getByUID(
      'main_navigation_new_version2',
      'main_navigation_new_version2',
      ref ? { ref } : null
    )
      .then((res) => ['header', res])
      .catch(() => null)
  );
  globalPropsRequests.push(
    Prismic.getByUID('footer', 'footer', ref ? { ref } : null)
      .then((res) => ['footer', res])
      .catch(() => null)
  );

  await Promise.all(globalPropsRequests)
    .then((responses) => {
      responses.forEach((res) => {
        if (res) {
          const [id, body] = res;
          if (id === 'menu_rts') menu = body.data;
          else global[id] = body.data;
        }
      });
    })
    .catch(() => null);

  const content = await Prismic.getByUID(
    'ready_to_ship_page',
    `rts-${handle}`,
    ref ? { ref } : null
  );
  if (!content) {
    return { notFound: true };
  }

  return {
    props: {
      global,
      handle,
      content: content?.data || null,
      // menu,
      preview,
    },
    revalidate: 300,
  };
}

export async function getStaticPaths() {
  return {
    paths: [
      { params: { handle: 'desktops' } },
      { params: { handle: 'laptops' } },
    ],
    fallback: true,
  };
}

export default readyToShip;
